module.exports = __webpack_public_path__ + "static/media/trofeus (7).f845a14c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/fotos/Trofeus/trofeus (7).jpg
// module id = 371
// module chunks = 0